<template>
  <div>
    <div class="container ptx20 phx20">
      <div class="pv2">
        <nuxt-link :to="localePath({ name: 'index' })" class="mr1"
          ><img
            src="~/assets/icons/ic_home.svg"
            width="16"
            height="16"
            class="v-mid"
        /></nuxt-link>
        <img
          src="~/assets/icons/ic_arrow_bc.svg"
          width="6"
          height="10"
          class="mr1"
        />
        <span class="breadcrumb-silver mr1">{{
          $t('navigation.services')
        }}</span>
        <img
          src="~/assets/icons/ic_arrow_bc.svg"
          width="6"
          height="10"
          class="mr1"
        />
        {{ $t(`cities.${currentCountry}.${cityKey}`) }}
      </div>
      <h1 v-if="services.length" class="mb2">
        {{
          $t(`cities.servicesHeading`, {
            city: cityLocationTranslation,
          })
        }}
      </h1>
      <h1 v-else class="f2 mt4 pt2">
        {{ $t(`cities.noServicesHeading`) }}
      </h1>
      <div
        v-if="promos.length > 0"
        v-swiper="swiperOptions"
        class="slide-container overflow-hidden db"
      >
        <div class="swiper-wrapper slide-wrapper">
          <div
            v-for="(promo, index) in promos"
            :key="index"
            class="swiper-slide slider"
          >
            <nuxt-link
              :to="
                localePath({ name: 'news-slug', params: { slug: promo.slug } })
              "
              :class="promos.length === index + 1 ? 'last' : ''"
              class="slider slide w-100 relative db h-100 card br3 overflow-hidden flex-l no-underline"
            >
              <div class="w-100 w-two-thirds-l h-100 slide-image">
                <img
                  :src="promo.imageCover || promo.image"
                  class="image-cover"
                />
              </div>
              <div
                class="w-100 absolute absolute--fill static-l w-third-l pa2 pa4-l slide-content"
              >
                <div class="absolute static-l bottom-2">
                  <p class="slide-title fw7 ma0">{{ promo.title }}</p>
                  <p class="fs-title ma0 mv2-l">
                    {{ promo.short }}
                  </p>
                </div>
              </div>
            </nuxt-link>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div class="mb4 overflow-hidden">
      <div v-for="service in services" :key="service.title">
        <div class="container phx20">
          <div class="flex items-center justify-between">
            <nuxt-link
              :to="
                localePath({
                  name: 'services-city-service',
                  params: {
                    city: $route.params.city,
                    service: service.slug,
                  },
                })
              "
              class="no-underline"
            >
              <h2 class="">{{ service.localizedTitle[currentLang] }}</h2>
            </nuxt-link>
            <div>
              <nuxt-link
                :to="
                  localePath({
                    name: 'services-city-service',
                    params: {
                      city: $route.params.city,
                      service: service.slug,
                    },
                  })
                "
              >
                {{ $t('common.showAll') }} ({{ service.skills.length }})
              </nuxt-link>
            </div>
          </div>
        </div>
        <div
          class="container services-container flex overflow-x-scroll overflow-x-hidden-l"
        >
          <nuxt-link
            v-for="skill in service.skills"
            :key="skill.title"
            :to="
              localePath({
                name: 'services-city-service-skill',
                params: {
                  city: $route.params.city,
                  service: service.slug,
                  skill: skill.slug,
                },
              })
            "
            class="nuxt-link db w-40 w-third-l ph1 ph3-l overflow-hidden no-underline"
            style="flex-shrink: 0"
          >
            <div class="bg-white overflow-hidden br3 card mb4">
              <div class="service-card">
                <img :data-src="skill.image" class="image-cover lazyload" />
              </div>
              <div class="pa2 pa3-l">
                <div class="flex items-center service-card-text">
                  <p class="lh-copy f4 fw5 mv0">
                    {{ skill.localizedTitle[currentLang] }}
                  </p>
                </div>
                <p v-if="skill.areaPriceStats" class="mv1">
                  {{ $t('common.from') }}
                  <Amount :value="skill.areaPriceStats" />{{ ' / ' }}
                  {{ $t('common.perHour') }}
                </p>
              </div>
            </div>
          </nuxt-link>
        </div>
      </div>
    </div>
    <div class="bg-near-white">
      <DownloadNow />
    </div>
  </div>
</template>

<script>
import marked from 'marked';
import slug from 'slug';
import { directive } from 'vue-awesome-swiper';
import DownloadNow from '~/components/DownloadNow';
import Amount from '~/components/Amount';
import utils from '~/plugins/utilities';
import api from '~/services/api';

async function loadServicesAndSkills(context, city, app, lang) {
  const services = [];
  const skills = [];
  const response = await api.getServices(context);
  Object.values(response.services)
    .sort((d2, d1) => (d1.sortPriority || 0) - (d2.sortPriority || 0))
    .forEach((data) => {
      const trans = data.localizedTitle[lang];
      if (!trans) {
        return;
      }
      services.push({
        id: data.id,
        skills: data.skills,
        title: data.title,
        localizedTitle: data.localizedTitle,
        image: data.image,
        slug: slug(data.localizedTitle[lang], { locale: lang }),
        description: data.description,
      });
    });
  Object.values(response.skills)
    .sort((d2, d1) => (d1.sortPriority || 0) - (d2.sortPriority || 0))
    .forEach((data) => {
      // if (!data.hidden) {
      const trans = data.localizedTitle[lang];
      if (
        trans &&
        !data.hidden &&
        data.areaPriceStats &&
        data.areaPriceStats[city] &&
        (city !== 'warsaw' || app.$config.FT_PL_ORDERS)
      ) {
        skills.push({
          id: data.id,
          serviceId: data.serviceId,
          title: data.title,
          localizedTitle: data.localizedTitle,
          image: data.image,
          areaPriceStats: data.areaPriceStats[city].from,
          slug: slug(data.localizedTitle[lang], { locale: lang }),
        });
      }
    });
  return { services, skills };
}

function getServicesWithSkills(services, skills) {
  // join services with skills
  services.forEach((service) => {
    service.skills = skills.filter((skill) => skill.serviceId === service.id);
  });
  // return services with no skills
  return services.filter((service) => service.skills.length > 0);
}

function resolveCity(cityKey, app, locale) {
  return slug(app.i18n.messages[locale].cities[locale.split('-')[1]][cityKey], {
    locale: locale.split('-')[0],
  });
}

export default {
  scrollToTop: true,
  components: {
    DownloadNow,
    Amount,
  },
  directives: {
    swiper: directive,
  },
  validate({ params, app }) {
    const cityParam = params.city;
    const cityKey = utils.getCityCodeFromRouterParam(cityParam, app.i18n);
    return cityKey && true;
  },
  async asyncData(context) {
    const { params, app, store, $firebaseDb, $sentry } = context;
    try {
      // get locale and path params
      const lang = app.i18n.locale.split('-')[0];
      const country = app.i18n.locale.split('-')[1];
      const cityParam = params.city;
      // get city key from translated param
      const cityKey = utils.getCityCodeFromRouterParam(cityParam, app.i18n);
      // translate different language routes for language switched
      const transParams = await new Promise((resolve) => {
        const routesToResolve = {};
        Object.keys(app.i18n.messages).forEach((key) => {
          if (key.split('-')[1] === country) {
            routesToResolve[key] = {
              city: resolveCity(cityKey, app, key),
            };
          }
        });
        resolve(routesToResolve);
      });
      store.dispatch('i18n/setRouteParams', transParams);
      // fetch skills, services and promos
      const response = await loadServicesAndSkills(context, cityKey, app, lang);
      const services = response.services;
      const skills = response.skills;
      const servicesWithSkills = getServicesWithSkills(services, skills);
      const locale = app.i18n.locale;
      const promos = [];
      const postsSnap = await $firebaseDb
        .collection('news')
        .where('language', '==', locale.split('-')[0])
        .where('cities', 'array-contains', cityKey)
        .where('active', '==', true)
        .orderBy('date', 'desc')
        .get();
      postsSnap.forEach((post) => {
        const data = post.data();
        promos.push({
          slug: post.id,
          image: data.image,
          imageCover: data.imageCover,
          title: data.title,
          short: data.short,
        });
      });
      return { services: servicesWithSkills, promos: [], cityKey };
    } catch (error) {
      $sentry.captureException(error);
      throw error;
    }
  },
  data() {
    return {
      services: [],
      promos: [],
      cityKey: '',
      swiperOptions: {
        loop: true,
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
        autoplay: {
          delay: 5000,
        },
      },
    };
  },
  computed: {
    currentLang() {
      return this.$i18n.locale.split('-')[0];
    },
    currentCountry() {
      return this.$i18n.locale.split('-')[1];
    },
    cityLocationTranslation() {
      const country = this.$i18n.locale.split('-')[1];
      const key = 'cities.' + country + '-location.' + this.cityKey;
      const translation = this.$t(key);
      if (translation === key) {
        return this.$t('cities.' + country + '.' + this.cityKey);
      } else {
        return translation;
      }
    },
  },
  methods: {
    htmlFromMd(text) {
      return marked(text);
    },
  },
  head() {
    return {
      title: this.$t(`cities.servicesHeading`, {
        city: this.cityLocationTranslation,
      }),
      meta: [
        // hid is used as unique identifier. Do not use `vmid` for it as it will not work
        {
          hid: 'description',
          name: 'description',
          content: '',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: '',
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.$t(`cities.servicesHeading`, {
            city: this.cityLocationTranslation,
          }),
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://discontract.com${this.$route.path.replace(
            /\/?$/,
            '/'
          )}`,
        },
      ],
    };
  },
};
</script>
